import React from "react";
import { useI18n } from "../i18n";

const Stats = () => {
  const { t } = useI18n();
  return (
    <section id="results" data-testid="stats-section" className="py-20 md:py-28 bg-slate-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
           style={{ backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)", backgroundSize: "32px 32px" }} />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="max-w-2xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-400 mb-4">
            {t.stats.eyebrow}
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-semibold leading-tight">
            {t.stats.title}
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-slate-800 border border-slate-800 rounded-2xl overflow-hidden">
          {t.stats.items.map((it, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="bg-slate-900 p-8 md:p-10 hover:bg-slate-800/50 transition-colors"
            >
              <div className="font-display text-4xl md:text-6xl font-semibold text-white tabular">
                {it.value}
              </div>
              <div className="mt-3 text-sm md:text-base text-slate-400">{it.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
